import { styled } from '@lessonup/ui-components';
import { Decorator } from '@storybook/react-webpack5';
import React from 'react';

export const FullScreenDecorator: Decorator = (Story: React.ComponentType) => {
  return (
    <FullScreen>
      <Story />
    </FullScreen>
  );
};

const FullScreen = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
`;
